import classNames from 'classnames';
import { FC } from 'react';

type DiscountSize = 'small' | 'large';

interface Props {
  text: string;
  onClick?: () => void;
  rounded?: boolean;
  rotated?: boolean;
  size?: DiscountSize;
}

const Discount: FC<Props> = ({
  text,
  onClick,
  rounded = false,
  rotated = false,
  size,
}) => {
  const discountClasses = classNames('discount', {
    [`discount--${size}`]: size,
    'discount--rounded': rounded,
    'discount--rotated': rotated,
  });

  return (
    <div className={discountClasses} data-testid="discount">
      {text}
      {onClick && (
        <button className="discount__button" onClick={onClick}>
          <i className="discount__icon fas fa-question-circle" />
        </button>
      )}
    </div>
  );
};

export default Discount;
